module.exports = __webpack_public_path__ + "static/media/right_arrow.4fd076ea.svg";